import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import api, { formatApiErrorDetail } from '../services/api';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [formData, setFormData] = useState({
    new_password: '',
    confirm_password: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Token de restablecimiento no proporcionado');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (formData.new_password !== formData.confirm_password) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (formData.new_password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    if (formData.new_password.length > 72) {
      setError('La contraseña no puede tener más de 72 caracteres');
      return;
    }

    setLoading(true);
    try {
      await api.post('/api/v1/email/reset-password', {
        token: token,
        new_password: formData.new_password
      });
      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      console.error('Error resetting password:', error);
      setError(formatApiErrorDetail(error, 'Error al restablecer la contraseña. El token puede ser inválido o haber expirado.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="min-vh-100 d-flex align-items-center"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}
    >
      <Container>
        <div className="d-flex justify-content-center">
          <Card className="shadow-lg border-0" style={{ maxWidth: '500px', width: '100%' }}>
            <Card.Body className="p-4 p-md-5">
              <div className="text-center mb-4">
                <img 
                  src="/LOGO-DIRESA.png" 
                  alt="Logo DIRESA" 
                  className="mb-3"
                  style={{ maxHeight: '80px', width: 'auto' }}
                />
                <h2 className="fw-bold text-primary mb-2">Restablecer Contraseña</h2>
                <p className="text-muted">Ingresa tu nueva contraseña</p>
              </div>

              {success && (
                <Alert variant="success" className="mb-4">
                  <Alert.Heading>¡Contraseña Restablecida!</Alert.Heading>
                  <p>Tu contraseña ha sido restablecida exitosamente. Redirigiendo al login...</p>
                </Alert>
              )}

              {error && (
                <Alert variant="danger" dismissible onClose={() => setError('')} className="mb-4">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  {error}
                </Alert>
              )}

              {!success && (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nueva Contraseña *</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Ingresa tu nueva contraseña"
                      value={formData.new_password}
                      onChange={(e) => setFormData({ ...formData, new_password: e.target.value })}
                      required
                      minLength={6}
                      maxLength={72}
                    />
                    <Form.Text className="text-muted">
                      Mínimo 6 caracteres
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Confirmar Contraseña *</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Confirma tu nueva contraseña"
                      value={formData.confirm_password}
                      onChange={(e) => setFormData({ ...formData, confirm_password: e.target.value })}
                      required
                      minLength={6}
                      maxLength={72}
                    />
                  </Form.Group>

                  <Button 
                    variant="primary" 
                    type="submit" 
                    className="w-100 mb-3"
                    disabled={loading || !token}
                  >
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Restableciendo...
                      </>
                    ) : (
                      'Restablecer Contraseña'
                    )}
                  </Button>
                </Form>
              )}

              <div className="text-center">
                <Link to="/login" className="text-decoration-none">
                  Volver al Login
                </Link>
              </div>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default ResetPassword;

